import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Bet_model from "./betmodel1/Bet_model"; 

const tossData = [
  {
    team: "Boland",
    odd: "1.98",
    matched: "2.8M",
  },
  {
    team: "Wariors",
    odd: "1.98",
    matched: "2.5M",
  },
];

const TossWinner = () => {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpen = (team, odd) => {
    setSelected({
      team,
      odd,
      type: "back",
    });

    setShow(true);
  };

  const openInfoModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <div className="winner-container">
        {/* HEADER */}
        <div className="header-row">
          <span className="header-title">
            Which Team Will Win The Toss{" "}
            <button
              onClick={openInfoModal}
              style={{
                cursor: "pointer",
                marginLeft: "5px",
                background: "none",
                border: "none",
                fontSize: "16px",
                color: "white",
              }}
            >
              ⓘ
            </button>
          </span>

          <span className="matche">
            Matched <b>€ 626.8K</b>
          </span>
        </div>

        {/* UI BLOCK */}
        <div
          style={{
            background: "#d9f7df",
            borderRadius: "10px",
            padding: "25px 10px",
            marginTop: "2px",
            marginBottom: "5px",
          }}
        >
          <div className="row">
            {tossData.map((row, i) => (
              <div
                className="col-6"
                key={i}
                style={{
                  textAlign: "center",
                  borderRight: i === 0 ? "1px solid #c1eac4" : "none",
                }}
              >
                <h6 style={{ fontWeight: "bold", color: "black" }}>{row.team}</h6>

                <div
                  style={{
                    background: "#7ef5a0",
                    display: "inline-block",
                    padding: "8px 30px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                  onClick={() => handleOpen(row.team, row.odd)}
                >
                  {row.odd}
                </div>

                <div
                  style={{
                    marginTop: "6px",
                    fontSize: "13px",
                    color: "#0b0b0b",
                  }}
                >
                  {row.matched}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* BET MODAL */}
        <Bet_model
          show={show}
          selected={selected}
          handleClose={() => setShow(false)}
        />

        {/* INFO MODAL */}
        {showModal && (
          <>
            <div className="modal-overlay" onClick={closeModal}></div>

            <div className="modal-box">
              <h3>Information</h3>

              <div className="modal-content">
                <p>
                  This is the Toss Market. Click on any odds to place your
                  selection.
                </p>
                <p>
                  Gulf Giants and Desert Vipers both have equal odds as shown in
                  the UI.
                </p>
              </div>

              <button className="close-btn" onClick={closeModal}>
                ok
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TossWinner;
